import { PureComponent, ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouterProps } from '../../../../../pages/prescriptionPad/magicBox/routerProps';

interface Props extends RouteComponentProps<RouterProps> {
    onContinue: () => void;
}

class BottomActionStrip extends PureComponent<Props> {
    render(): ReactNode {
        const { onContinue } = this.props;

        return (
            <div className="flex items-center justify-end absolute rounded-8 bg-actionPrimary bottom-24 inset-x-10 px-16 py-8 cta-row z-1">
                <button
                    onClick={onContinue}
                    className="px-16 py-8 btn--small primary-btn-v2 tooltip-wrapper"
                >
                    <div className="flex items-center justify-center w-16 h-16">
                        <svg
                            className="w-16 h-16 fill-actionPrimary"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            style={{ rotate: '180deg' }}
                        >
                            <path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"></path>
                        </svg>
                    </div>
                    <p>Continue To Prescription</p>
                </button>
            </div>
        );
    }
}

export default withRouter(BottomActionStrip);
